import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { BUGSNAG_API_KEY } from '@/helpers/constants/app';
Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
    enabledReleaseStages: ['production', 'staging'],
    appVersion: '2.42.24',
});
export default Bugsnag;
